import { Input, Label } from "./styles";

export default function UnlimitedAnswers({
  hasUnlimitedAnswers = false,
  onChangeHasUnlimitedAnswers = () => null,
}) {
  return (
    <Label title="Aceita diversas respostas do mesmo email">
      <Input
        type="checkbox"
        checked={hasUnlimitedAnswers}
        onChange={(e) => onChangeHasUnlimitedAnswers(e.target.checked)}
      />
      <span>Sem limite de respostas</span>
    </Label>
  );
}
